import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { useLogEvent } from '~/hooks/useLogEvent'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useDeleteBrandAccountMutation } from '../hooks/useDeleteBrandAccountMutation'

export const DeleteBrandAccountDialog = () => {
  const { t } = useTranslation()
  const dialogInfo = useAtomValue(dialogInfoAtom)
  if (dialogInfo?.dialogType !== 'delete') {
    throw new Error()
  }
  const { brandAccount } = dialogInfo

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const logEvent = useLogEvent()
  const deleteBrandAccountMutation = useDeleteBrandAccountMutation({
    onSuccess: (data) => {
      // 対象が既に削除されている場合などdeleteBrandAccountはresult: falseを返す。削除できていないので記録しない。
      if (data.deleteBrandAccount?.result) {
        logEvent('Delete brand account', {
          eventProperties: [
            { key: 'brand account id', value: brandAccount.id },
            { key: 'name', value: brandAccount.name },
          ],
        })
      }
      closeDialogWithRefresh()
    },
  })
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    deleteBrandAccountMutation.mutate(brandAccount.id)
  }, [brandAccount.id, deleteBrandAccountMutation])

  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  return (
    <ExecuteCancelDialog
      executing={deleteBrandAccountMutation.isPending}
      mode="delete"
      title={t('delete_brand_account')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_confirmation', { target: brandAccount.name })}
    </ExecuteCancelDialog>
  )
}
